export default "__VITE_ASSET__59da9093__"